import { AuthHeader, makeAuthHeader, makeV2APIURL, VersionHeader } from '^/store/duck/API';
import * as T from '^/types';
import { http } from '^/utilities/api';
import { GetPhotoAlbumByIdResponse } from '../photos/services';

export const VIEWPORTS_LIMIT = 10;

export const requestDroneCapture = async (photoAlbumId: T.RequestPhoto['id']) => {
  const URL = makeV2APIURL('photo_albums', photoAlbumId, 'request');

  try {
    const res = await http.post(URL);
    return res.data.data as T.PhotoAlbum;
  } catch (error) {
    console.error(error);
    throw new Error('Network error');
  }
};

export const getV2BAlbums = async (
  projectId: number,
  authHeader: AuthHeader,
  versionHeader: VersionHeader
) => {
  const URL = makeV2APIURL('projects', projectId, 'photo_albums?type=viewpoint');
  const response = await http.get(URL, {
    headers: { ...authHeader, ...versionHeader },
  });
  return response.data.data as T.PhotoAlbum[];
};

export const getV2BAlbumById = async (
  photoUrl: string,
  authHeader: AuthHeader,
  versionHeader: VersionHeader
) => {
  const response: { data: GetPhotoAlbumByIdResponse } = await http.get(photoUrl, {
    headers: { ...authHeader, ...versionHeader },
  });
  return response.data.data;
};

interface RenameViewpointAlbumParams {
  albumId: T.PhotoAlbum['id'];
  newTitle: string;
  auth: T.AuthState;
  planConfigSlug?: string;
}

export const renameViewpointAlbum = async ({
  albumId,
  newTitle,
  auth,
  planConfigSlug,
}: RenameViewpointAlbumParams) => {
  const URL = makeV2APIURL('photo_albums', albumId);
  const header = makeAuthHeader(auth, planConfigSlug);

  const response = await fetch(URL, {
    method: 'PATCH',
    headers: {
      ...header,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: albumId,
      title: newTitle,
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to rename photo album');
  }

  const data = await response.json();
  const updatedAlbum = data?.data as T.PhotoAlbum;
  return { albumId, updatedAlbum };
};

export interface CreateNewViewpointAlbumParams {
  title: string;
}
export const createNewViewpointAlbum = async ({ title }: CreateNewViewpointAlbumParams) => {
  const newAlbum: T.PhotoAlbumbyId = {
    id: Math.floor(Math.random() * 10000),
    title,
    photos: [],
    type: T.PhotoAlbumFilterTypes.VIEWPOINT,
    photosCount: 0,
    contentId: null,
    takenAt: new Date(),
    status: T.RequestPhotoStatus.PENDING,
    requestedAt: undefined,
  };
  await new Promise(resolve => setTimeout(() => resolve(newAlbum), 1000));
  return newAlbum;
};

export const deleteViewpointAlbum = async (
  albumId: T.PhotoAlbum['id'],
  authHeader: AuthHeader,
  versionHeader: VersionHeader
) => {
  const URL = makeV2APIURL('photo_albums', albumId);
  const response = await http.delete(URL, {
    headers: { ...authHeader, ...versionHeader },
  });
  return response.data.data as T.PhotoAlbum;
};

export interface DeleteViewpointPhotoParams {
  photoId: T.Photo['id'];
  authHeader: AuthHeader;
}
export const deleteViewpointPhoto = async ({ photoId, authHeader }: DeleteViewpointPhotoParams) => {
  const URL = makeV2APIURL('photos', photoId);
  await http.delete(URL, {
    headers: { ...authHeader },
  });
  return { photoId };
};
